<div class="main-container">
  <textarea class="notes-input" name="" id="" placeholder="Add Notes Here..." [(ngModel)]="data" (ngModelChange)="onDataChange()"></textarea>
</div>